import { render, staticRenderFns } from "./parcel-timeline.vue?vue&type=template&id=2b3def6f"
import script from "./parcel-timeline.vue?vue&type=script&lang=js"
export * from "./parcel-timeline.vue?vue&type=script&lang=js"
import style0 from "./parcel-timeline.vue?vue&type=style&index=0&id=2b3def6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports